import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectNewsMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_NEWS_MESSAGE);
        this.NewsGroupsArr = [];
    }
}
